export enum CommunicationType {
  None = -1,
  Phone,
  Mail,
  Email,
  InPerson,
  SMS,
}
